import React, {useState, useContext} from 'react';
import {Grid, Typography, Divider, ClickAwayListener} from '@material-ui/core';
import {useFormikContext} from "formik";
import "../../../../../../App.css";
import {Checkbox} from '@mantine/core';
import {makeStyles, styled} from "@material-ui/core/styles";
import PopOverDetails from "../../../../../PopOverInfo";
import AffinityInfoContext from "../../../../../../context/AffinityContext";
import Tooltip, {tooltipClasses} from "@mui/material/Tooltip";
import MantineNumberField from "../../../../FormikUtils/MantineNumberField";
import {IconBike, IconCamera, IconDeviceLaptop, IconDeviceTablet, IconScooter} from "@tabler/icons";

const useStyles = makeStyles((theme) => ({
    coverageIcon: {
        width: "32px",
        height: "32px",
        strokeWidth: "2px",
    },
    coberturasTable: {
        padding: theme.spacing(1),
    },
    tableHeader: {
        fontFamily: 'EncodeSansBold',
        fontSize: 18
    },
    tableRowLabel: {
        fontFamily: 'EncodeSansRegular',
        maxWidth: "90%",
        fontSize: 14
    },
    tableRowLabelAditional: {
        fontFamily: 'EncodeSansRegular',
        fontSize: 12,
        maxWidth: "90%"
    },
    centerContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    alert: {
        backgroundColor: theme.palette.warning.dark
    },
    arrow: {
        fontSize: 14,
        "&::before": {
            backgroundColor: "#FFF",
            color: "#FFF",
            boxShadow: '8px 2px 8px #888888',
            border: '1px solid #dadde9',
        }
    },
}));

const HtmlTooltip = styled(({className, arrowClass, handleCloseTooltip, ...props}) => (
    <ClickAwayListener onClickAway={handleCloseTooltip}>
        <Tooltip {...props} classes={{popper: className, arrow: arrowClass}}/>
    </ClickAwayListener>
))(({}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        fontSize: "12px",
        color: 'rgba(0, 0, 0, 0.87)',
        padding: "8px",
        boxShadow: "6px 10px 16px #888888",
        maxWidth: "200px",
        textAlign: "center",
        border: '1px solid #dadde9',
    },
}));

export default function CoberturasFormMobile() {
    const {coberturasInfo} = useContext(AffinityInfoContext);
    const classes = useStyles();
    const {values, setFieldValue} = useFormikContext();
    const [openTooltip, setOpenTooltip] = useState(true);
    const coberturasAdicionalesIcons = {
        26: <IconCamera className={classes.coverageIcon}/>,
        36: <IconDeviceLaptop className={classes.coverageIcon}/>,
        37: <IconDeviceTablet className={classes.coverageIcon}/>,
        48: <IconBike className={classes.coverageIcon}/>,
        49: <IconScooter className={classes.coverageIcon}/>,
    }

    const handleCloseTooltip = () => {
        setOpenTooltip(false);
    };

    return (
        <React.Fragment>
            <Grid container direction='column'>
                <Grid item container spacing={3} direction='column' className={classes.coberturasTable}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        margin: "8px 16px",
                    }}>
                        <Typography className={classes.tableHeader}>Cobertura</Typography>
                        <Typography className={classes.tableHeader}>Suma Asegurada</Typography>
                    </div>

                    {Object.keys(values.coberturas).map((cobertura, index) => {
                        return (
                            <>
                                <div style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    margin: "16px",
                                }}>
                                    <div style={{width: "60%"}}>
                                        <Typography className={classes.tableRowLabel}>
                                            {coberturasInfo[cobertura].descripcion}
                                        </Typography>
                                    </div>

                                    {index === 0 ? (
                                        <HtmlTooltip
                                            title={
                                                <React.Fragment>
                                                    <p>Presionando aquí, podrás modificar los montos asegurados
                                                        sugeridos</p>
                                                </React.Fragment>
                                            }
                                            arrow
                                            arrowClass={classes.arrow}
                                            open={openTooltip}
                                            handleCloseTooltip={handleCloseTooltip}
                                            placement="bottom-end"
                                        >
                                            <div style={{width: "30%"}}>
                                                <MantineNumberField
                                                    name={`coberturas.${cobertura}.sumaAsegurada`}
                                                    label={""}
                                                    min={coberturasInfo[cobertura]['sumaMinima']}
                                                    max={coberturasInfo[cobertura]['sumaMaxima']}
                                                    styles={{input: {textAlign: "right", fontSize: "12px"}}}
                                                />
                                            </div>
                                        </HtmlTooltip>
                                    ) : (
                                        <div style={{width: "30%"}}>
                                            <MantineNumberField
                                                name={`coberturas.${cobertura}.sumaAsegurada`}
                                                label={""}
                                                min={coberturasInfo[cobertura]['sumaMinima']}
                                                max={coberturasInfo[cobertura]['sumaMaxima']}
                                                styles={{input: {textAlign: "right", fontSize: "12px"}}}
                                            />
                                        </div>
                                    )}

                                    <div style={{width: "10%"}}>
                                        <PopOverDetails
                                            descripcion={coberturasInfo[cobertura].descripcionCompleta}
                                            isMobile={true}/>
                                    </div>
                                </div>
                                <Divider light/>
                            </>
                        )

                    })}

                    <Grid item container spacing={3} direction='column' className={classes.coberturasTable}>

                        <Typography className={classes.tableHeader} style={{margin: "24px 0px 8px 16px"}}>
                            Adicionales
                        </Typography>
                        {Object.keys(values.coberturasAdicionales).map(cobertura => {
                            return (
                                <>
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        margin: "16px",
                                    }}>
                                        <div style={{
                                            width: "60%", display: "flex",
                                            flexDirection: "row", alignItems: "center", justifyContent: "space-between",
                                        }}>
                                            <div style={{width: "15%", marginLeft: "-8px"}}>
                                                <Checkbox
                                                    checked={values.coberturasAdicionales[cobertura].selectedCobertura}
                                                    classNames={{
                                                        input: "checkbox",
                                                        root: "checkbox",
                                                        body: "checkbox",
                                                    }}
                                                    size="sm"
                                                    onChange={(e) => {
                                                        const {checked} = e.target;
                                                        setFieldValue(`coberturasAdicionales.[${cobertura}].selectedCobertura`, checked);
                                                    }}
                                                />
                                            </div>

                                            <div style={{
                                                width: "20%",
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                            }}>
                                                <Grid item xs={2} className={classes.centerContent}>
                                                    {coberturasAdicionalesIcons[cobertura]}
                                                </Grid>
                                            </div>

                                            <div style={{width: "55%"}}>

                                                <Typography className={classes.tableRowLabelAditional}>
                                                    {coberturasInfo[cobertura].descripcion}
                                                </Typography>

                                            </div>

                                        </div>

                                        <div style={{
                                            visibility: values.coberturasAdicionales[cobertura] && values.coberturasAdicionales[cobertura].selectedCobertura ? "visible" : "hidden",
                                            width: "30%"
                                        }}>
                                            <MantineNumberField
                                                name={`coberturasAdicionales.${cobertura}.sumaAsegurada`}
                                                min={coberturasInfo[cobertura]['sumaMinima']}
                                                max={coberturasInfo[cobertura]['sumaMaxima']}
                                                styles={{input: {textAlign: "right", fontSize: "12px"}}}
                                            />

                                        </div>
                                        <div style={{width: "10%"}}>
                                            <PopOverDetails
                                                descripcion={coberturasInfo[cobertura].descripcionCompleta}
                                                isMobile={true}
                                            />
                                        </div>
                                    </div>
                                </>
                            )
                        })}
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
